(function() {
  'use strict';

  var STICKY_ID = 'pds-sticky-atc';
  var VISIBLE_CLASS = 'pds-sticky-atc--visible';
  var BODY_CLASS = 'pds-has-sticky-atc';
  var BODY_SHOWN_CLASS = 'pds-sticky-atc-shown';

  function init() {
    var sticky = document.getElementById(STICKY_ID);
    if (!sticky) return;

    if (window.innerWidth >= 990) return;

    var mainAtcButton = document.querySelector('product-form button[name="add"], form[action*="/cart/add"] button[type="submit"]');

    if (!mainAtcButton) {
      console.warn('[PDS Sticky ATC] Bouton ATC principal introuvable');
      return;
    }

    document.body.classList.add(BODY_CLASS);

    var stickyButton = document.getElementById('pds-sticky-atc-button');
    if (stickyButton) {
      stickyButton.addEventListener('click', function(e) {
        e.preventDefault();
        handleStickyAddToCart(stickyButton, mainAtcButton);
      });
    }

    var scrollTimer = null;
    function onScroll() {
      if (scrollTimer) return;
      scrollTimer = setTimeout(function() {
        updateVisibility(sticky, mainAtcButton);
        scrollTimer = null;
      }, 50);
    }

    function updateVisibility(stickyEl, atcButton) {
      var rect = atcButton.getBoundingClientRect();
      var shouldShow = rect.bottom < 0 || rect.top > window.innerHeight;

      if (shouldShow) {
        stickyEl.classList.add(VISIBLE_CLASS);
        document.body.classList.add(BODY_SHOWN_CLASS);
      } else {
        stickyEl.classList.remove(VISIBLE_CLASS);
        document.body.classList.remove(BODY_SHOWN_CLASS);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function() {
      if (window.innerWidth >= 990) {
        sticky.classList.remove(VISIBLE_CLASS);
        document.body.classList.remove(BODY_CLASS);
        document.body.classList.remove(BODY_SHOWN_CLASS);
      } else {
        document.body.classList.add(BODY_CLASS);
      }
    });

    updateVisibility(sticky, mainAtcButton);

    listenToVariantChanges();
  }

  function handleStickyAddToCart(stickyButton, mainAtcButton) {
    var originalText = stickyButton.textContent;
    stickyButton.classList.add('pds-sticky-atc__button--loading');
    stickyButton.textContent = '...';

    mainAtcButton.click();

    setTimeout(function() {
      stickyButton.classList.remove('pds-sticky-atc__button--loading');
      stickyButton.classList.add('pds-sticky-atc__button--success');
      stickyButton.textContent = '✓ Ajouté';

      setTimeout(function() {
        stickyButton.classList.remove('pds-sticky-atc__button--success');
        stickyButton.textContent = originalText;
      }, 1800);
    }, 600);
  }

  function listenToVariantChanges() {
    var stickyPrice = document.getElementById('pds-sticky-atc-price');
    var stickyButton = document.getElementById('pds-sticky-atc-button');
    if (!stickyPrice || !stickyButton) return;

    document.addEventListener('change', function(e) {
      if (e.target && (e.target.name === 'id' || e.target.matches('input[type="radio"], select'))) {
        setTimeout(syncFromMainForm, 100);
      }
    });

    function syncFromMainForm() {
      var mainPrice = document.querySelector('[id^="price-"] .price__regular .price-item--regular, .price__regular .price-item--regular, .price-item--sale, .price-item--regular');
      if (mainPrice) {
        stickyPrice.textContent = mainPrice.textContent.trim();
      }

      var mainButton = document.querySelector('product-form button[name="add"], form[action*="/cart/add"] button[type="submit"]');
      if (mainButton) {
        if (mainButton.disabled) {
          stickyButton.disabled = true;
          stickyButton.textContent = 'Épuisé';
        } else {
          stickyButton.disabled = false;
          stickyButton.textContent = 'Ajouter';
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();